import styled from "styled-components";
export var DevelopmentBannerHolder = styled.div.withConfig({
  displayName: "developmentBannerstyles__DevelopmentBannerHolder",
  componentId: "sc-1wqappv-0"
})(["display:flex;width:100%;padding:0 15px;height:50px;background:", ";align-items:center;justify-content:center;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.i5;
});
export var InlineLink = styled.a.withConfig({
  displayName: "developmentBannerstyles__InlineLink",
  componentId: "sc-1wqappv-1"
})(["text-decoration:underline;cursor:pointer;color:inherit;&:hover{opacity:0.8;}"]);